// TODO: Figure out if this is the allowed characters
// Breakdown of regex:
// \p{L} - Matches any letter from any language
// 0-9 - Matches any number
// _ - Matches an underscore
// () - Matches an open and close parenthesis
// \s - Matches any whitespace character
// - - Matches a hyphen
// {3,128} - Matches between 3 and 128 characters
export const ORGANIZATION_ALIAS_RULES = {
  regex: /^[\p{L}0-9_()\s-]{3,128}$/u,
  message: 'Organization name must be at least 3 characters and contain only letters, numbers, spaces, hyphens, and parentheses',
  invalidMessage: 'Invalid organization name',
};
